import { Observer } from 'mobx-react-lite'
import React from 'react'
import { MdOutlineDarkMode, MdOutlineLightMode } from 'react-icons/md'

import { useLayoutContext } from '@/Core/Layouts/DefaultLayout'
import { userManager } from '@/Core/Managers'
import { AppLogo } from '@/Ship/Components/UI/AppLogo/AppLogo'
import { InstallButton } from '@/Ship/Pwa/Components/InstallButton'
import { driverThemeStore } from '@/Ship/Pwa/DriverThemeStore'

import styles from './PwaHeader.module.css'

interface PwaHeaderProps {
    profileRouteKey?: string
    extraActions?: React.ReactNode
}

export const PwaHeader: React.FC<PwaHeaderProps> = ({ extraActions }) => {
    const layoutContext = useLayoutContext()

    // Вихід — у профілі, а не в шапці: випадковий дотик у кабіні не має розлогінювати.
    // У шапці лишається швидкий перемикач теми: на сонці водій вмикає світлу одним дотиком.
    return (
        <header className={styles['header']}>
            <div className={styles['logo']}>
                <AppLogo collapsed={true} />
            </div>

            <Observer>
                {() => {
                    const title = layoutContext?.states?.['layoutTitle'] || 'Autostrada'
                    return <span className={styles['title']}>{title}</span>
                }}
            </Observer>

            <div className={styles['actions']}>
                <InstallButton />

                {extraActions}

                <Observer>
                    {() =>
                        userManager.isAuthorized ? (
                            <button
                                className={styles['actionButton']}
                                onClick={() => driverThemeStore.toggle()}
                                aria-label={driverThemeStore.mode === 'dark' ? 'Світла тема' : 'Темна тема'}
                                title={driverThemeStore.mode === 'dark' ? 'Світла тема' : 'Темна тема'}
                            >
                                {driverThemeStore.mode === 'dark' ? <MdOutlineLightMode /> : <MdOutlineDarkMode />}
                            </button>
                        ) : null
                    }
                </Observer>
            </div>
        </header>
    )
}

PwaHeader.displayName = 'PwaHeader'
